import styled from 'styled-components';
import {tokens} from "../../../../../theme";
import {alpha} from "@mui/material/styles";

export const LicenseModulesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;
    align-items: stretch;
    justify-content: flex-start;
`;

export const ModulesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
    width: 100%;
`;

export const ModuleItem = styled.div`
    display: flex;
    flex-direction: row;
    padding: 1rem;
    align-items: center;
    gap: 1.5rem;
    background-color: ${({ theme }) => theme.palette.background.dropzone};
    border: 1px solid ${({ theme }) => theme.palette.dividers.light};
    border-radius: ${tokens.radius.lg};
`;

export const ModuleIcon = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px;
    color: ${({ theme }) => theme.palette.success.main};
    
    background-color: ${({ theme }) => alpha(theme.palette.success.light, 0.2)};
    border-radius: ${tokens.radius.sm};
`;